import { Logo } from "./LogoVariants";

const Footer = (props) => {
  const year = new Date().getFullYear();
  return (
    <footer className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-900 text-gray-400">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <div className="mb-4">
              <Logo variant="shield" size="md" />
            </div>
            <p className="text-gray-400 mb-4">
              AI-powered tax intelligence for Kenyan accountants. Catch
              compliance risks before filing with KRA.
            </p>
          </div>
          {!props.comingSoon && (
            <div>
              <h3 className="mb-4 text-white">Product</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#features"
                    className="hover:text-white transition-colors"
                  >
                    Features
                  </a>
                </li>
                <li>
                  <a
                    href="#how-it-works"
                    className="hover:text-white transition-colors"
                  >
                    How It Works
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Pricing
                  </a>
                </li>
              </ul>
            </div>
          )}

          {!props.comingSoon && (
            <div>
              <h3 className="mb-4 text-white">Company</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#founder"
                    className="hover:text-white transition-colors"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    className="hover:text-white transition-colors"
                  >
                    Contact
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
        <div className="pt-8 border-t border-gray-800 text-center">
          <p>
            &copy; {year} TaxMate. All rights reserved. Built for Kenyan
            accountants.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
